import React, { useEffect, useRef } from "react";
import RelatorioModuloElasticidadePrint from "./RelatorioModuloElasticidadePrint";
import "./RelatorioModuloElasticidadePrint.css";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";

function formatarDataBR(dataISO) {
  if (!dataISO) return "";
  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

function formatarDataExtenso(dataISO) {
  if (!dataISO) return "";

  const meses = [
    "janeiro",
    "fevereiro",
    "marco",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ];

  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  const data = new Date(`${dataISO}T00:00:00`);
  const diaSemana = data.toLocaleDateString("pt-BR", { weekday: "long" });
  return `${diaSemana}, ${Number(dia)} de ${meses[Number(mes) - 1]} de ${ano}`;
}

function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return null;
  const n = Number(String(valor).replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

function numeroBR(valor, casas = 1) {
  const n = typeof valor === "number" ? valor : numero(valor);
  if (n === null) return "";
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

function media(valores, casas = 1) {
  const nums = valores.map(numero).filter((v) => v !== null);
  if (!nums.length) return "";
  return numeroBR(nums.reduce((soma, item) => soma + item, 0) / nums.length, casas);
}

function valor(valorCampo, fallback = "-") {
  return valorCampo === "" || valorCampo === null || valorCampo === undefined ? fallback : valorCampo;
}

function diferencaDias(dataInicial, dataFinal) {
  if (!dataInicial || !dataFinal) return "";

  const inicio = new Date(`${dataInicial}T00:00:00`);
  const fim = new Date(`${dataFinal}T00:00:00`);
  if (Number.isNaN(inicio.getTime()) || Number.isNaN(fim.getTime())) return "";

  const dias = Math.round((fim.getTime() - inicio.getTime()) / 86400000);
  if (!Number.isFinite(dias) || dias < 0) return "";
  return `${dias} dias`;
}

function codigoResumo(codigo) {
  const match = String(codigo || "").match(/CE-RE-MED-(\d+)\/\d{4}/);
  return match ? String(Number(match[1])) : codigo || "-";
}

function codigoRomaneioResumo(modulo) {
  const codigo = codigoResumo(modulo.codigo);

  const romaneio =
    modulo.notaFiscalRomaneio ||
    modulo.notaFiscalRomaneioME ||
    modulo.notaFiscalRomaneioMe ||
    modulo.romaneioME ||
    modulo.romaneioMe ||
    modulo.romaneio ||
    modulo.numeroRomaneio ||
    modulo.nf ||
    modulo.numeroNotaFiscal ||
    modulo.notaFiscal ||
    modulo.numNotaFiscal ||
    modulo.numeroNF ||
    modulo.numeroNf ||
    modulo.nfRomaneio ||
    "";

  if (!romaneio) return codigo;

  return `${codigo} / ${romaneio}`;
}

function imprimirEmRetrato() {
  window.print();
}

function Cabecalho({ modulo, dataRelatorio }) {
  return (
    <>
      <table className="cabecalho">
        <tbody>
          <tr>
            <td rowSpan="3" className="logo-cell">
              <LogoRelatorio alt="Logo" className="logo"  />
            </td>
            <td rowSpan="3" className="titulo-principal">
              SISTEMA DE GESTÃO DA QUALIDADE
              <br />
              RELATÓRIO MÓDULO DE ELASTICIDADE
            </td>
            <td className="rq-cell">RQ 2.2.13</td>
          </tr>
          <tr>
            <td>REVISÃO 00</td>
          </tr>
          <tr>
            <td>20/08/2025</td>
          </tr>
        </tbody>
      </table>

      <div className="linha-info">
        <span>
          <strong>Data:</strong> {formatarDataBR(dataRelatorio)}
        </span>
      </div>
    </>
  );
}

function BlocoEmpresa({ modulo }) {
  return (
    <div className="bloco-empresa">
      <div>
        <strong>EMPRESA:</strong>
        <span>{valor(modulo.cliente)}</span>
      </div>
      <div>
        <strong>LOCAL/OBRA:</strong>
        <span>{valor(modulo.obra)}</span>
      </div>
    </div>
  );
}

function Assinatura({ modulo }) {
  return (
    <div className="assinatura-area">
      <div>{formatarDataExtenso(modulo.dataEnsaio || modulo.dataRelatorio)}</div>
      <div className="assinatura">
        <img src="/Images/assinaturaLeal.png" alt="Assinatura" />
        <div className="linha-assinatura" />
        <strong>José Carlos Lemes Leal</strong>
        <span>Eng. Civil CREA 203379/D - TO</span>
      </div>
    </div>
  );
}

function RodapeRestrito() {
  return (
    <div className="rodape-restrito">
      <div className="linha-rodape" />
      <div>DOCUMENTO PARA USO RESTRITO. REPRODUÇÃO/CÓPIA PROIBIDA SEM AUTORIZAÇÃO DA EMPRESA</div>
    </div>
  );
}

function PaginaResumo({ modulos, primeiroModulo, dataRelatorio, ultimaPagina }) {
  const dataCapa = dataRelatorio || primeiroModulo.dataRelatorio || primeiroModulo.dataEnsaio || "";

  return (
    <div className="pagina pagina-resumo-modulo">
      <Cabecalho modulo={primeiroModulo} dataRelatorio={dataCapa} />
      <BlocoEmpresa modulo={primeiroModulo} />

      <div className="titulo-resumo-modulo">
        Determinação dos módulos de elasticidade e de deformação NBR-8522-2
      </div>

      <table className="tabela-resumo-modulo">
        <colgroup>
          <col className="col-codigo-resumo" />
          <col className="col-moldagem-resumo" />
          <col className="col-peca-resumo" />
          <col className="col-ensaio-resumo" />
          <col className="col-idade-resumo" />
          <col className="col-modulo-resumo" />
        </colgroup>
        <thead>
          <tr>
            <th>CÓD / ROMANEIO (N.F.)</th>
            <th>Data da Moldagem dos corpos de Prova</th>
            <th>Peça Concretada</th>
            <th>Data do ensaio</th>
            <th>Idade</th>
            <th>Módulo de elasticidade estático (GPa)</th>
          </tr>
        </thead>
        <tbody>
          {modulos.map((modulo) => {
            const dataEnsaio = modulo.dataEnsaio || modulo.dataRelatorio;
            const idade = modulo.idadeCp || diferencaDias(modulo.dataMoldagem, dataEnsaio);

            return (
              <tr key={modulo.id || modulo.codigo}>
                <td>{codigoRomaneioResumo(modulo)}</td>
                <td>{formatarDataBR(modulo.dataMoldagem)}</td>
                <td>{valor(modulo.localAplicacao)}</td>
                <td>{formatarDataBR(dataEnsaio)}</td>
                <td>{valor(idade)}</td>
                <td>{media([modulo.moduloEciCp1, modulo.moduloEciCp2], 1)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {ultimaPagina && <Assinatura modulo={primeiroModulo} />}
      <RodapeRestrito />
    </div>
  );
}

function PaginasResumo({ modulos, dataRelatorio }) {
  const modulosPorPagina = 16;
  const primeiroModulo = modulos[0] || {};
  const paginas = [];

  for (let indice = 0; indice < modulos.length; indice += modulosPorPagina) {
    paginas.push(modulos.slice(indice, indice + modulosPorPagina));
  }

  return paginas.map((modulosPagina, indice) => (
    <PaginaResumo
      key={`resumo-${indice}`}
      modulos={modulosPagina}
      primeiroModulo={primeiroModulo}
      dataRelatorio={dataRelatorio}
      ultimaPagina={indice === paginas.length - 1}
    />
  ));
}

function PaginaCapaCertificado({ modulo }) {
  const dataRelatorio = modulo.dataRelatorio || modulo.dataEnsaio || new Date().toISOString().split("T")[0];

  return (
    <div className="pagina pagina-capa-certificado-modulo">
      <Cabecalho modulo={modulo} dataRelatorio={dataRelatorio} />
      <BlocoEmpresa modulo={modulo} />

      <div className="titulo-certificado-modulo">
        ANEXO - Certificado de calibração - Aparelho de Módulo Elasticidade.
      </div>

      <Assinatura modulo={modulo} />
      <RodapeRestrito />
    </div>
  );
}

function PaginaCertificado({ certificado }) {
  return (
    <div className="pagina pagina-pdf-certificado-modulo">
      <iframe
        title={certificado.nomeArquivoOriginal || "Certificado de calibração"}
        src={certificado.url}
      />
    </div>
  );
}

export default function RelatorioModuloElasticidadeMultiploPrint({ modulos = [], certificado = null, dataRelatorio = "", onVoltar, onSalvar, salvando = false, autoPrint = false }) {
  const jaImprimiuRef = useRef(false);

  useEffect(() => {
    if (!autoPrint || jaImprimiuRef.current) return;

    const timer = window.setTimeout(() => {
      if (jaImprimiuRef.current) return;
      jaImprimiuRef.current = true;
      imprimirEmRetrato();
    }, 500);

    return () => window.clearTimeout(timer);
  }, [autoPrint]);

  if (!modulos.length) return null;

  return (
    <div className="relatorio-modulo-elasticidade-print relatorio-modulo-multiplo">
      {onVoltar && (
        <div className="acoes-print">
          <button className="btn-voltar" onClick={onVoltar}>Voltar</button>
          {onSalvar && (
            <button className="btn-imprimir" onClick={onSalvar} disabled={salvando}>
              {salvando ? "Salvando..." : "Salvar relatório"}
            </button>
          )}
          <button className="btn-imprimir" onClick={imprimirEmRetrato}>Imprimir</button>
        </div>
      )}

      <PaginasResumo modulos={modulos} dataRelatorio={dataRelatorio} />
      {modulos.map((modulo) => (
        <RelatorioModuloElasticidadePrint
          key={modulo.id || modulo.codigo}
          modulo={modulo}
          mostrarCertificado={false}
        />
      ))}
      {certificado?.url && (
        <>
          <PaginaCapaCertificado modulo={modulos[0]} />
          <PaginaCertificado certificado={certificado} />
        </>
      )}
    </div>
  );
}

